<template>
  <div
    v-if="
      hasOneShowingChild(item.appColumnRespVOList, item) &&
      (!onlyOneChild.appColumnRespVOList || onlyOneChild.noShowingChildren)
    "
    class="menu-nav-item"
  >
    <app-link
      v-if="!isDevMenu(onlyOneChild.code)"
      :to="resolvePath(onlyOneChild.path, onlyOneChild.query)"
      :item="onlyOneChild"
      @click.native="activeMenuChange"
    >
      <el-menu-item
        :index="resolvePath(onlyOneChild.path)"
        :class="{ 'submenu-title-noDropdown': !isNest }"
      >
        <item
          :icon="onlyOneChild.icon || item.icon"
          :title="onlyOneChild.name"
        />
      </el-menu-item>
    </app-link>
    <div v-else @click.stop="devMenuClick">
      <el-menu-item
        :index="resolvePath(onlyOneChild.path)"
        :class="{ 'submenu-title-noDropdown': !isNest }"
      >
        <item
          :icon="onlyOneChild.icon || item.icon"
          :title="onlyOneChild.name"
        />
      </el-menu-item>
    </div>
  </div>
  <div v-else class="menu-nav-item">
    <el-submenu
      ref="subMenu"
      popper-class="my-submenu-pop"
      :class="{ 'is-active': activeIndex === resolvePath(item.path) }"
      :index="resolvePath(item.path)"
      :popper-append-to-body="false"
    >
      <template #title>
        <item :icon="item.icon" :title="item.name" />
      </template>
      <nav-item
        v-for="child in item.appColumnRespVOList"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        v-bind="$attrs"
        :active-index="activeIndex"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from "path";
import { isExternal } from "@/utils/validate";
import Item from "./Item";
import AppLink from "./Link";
import { mapGetters } from "vuex";
export default {
  name: "NavItem",
  components: { Item, AppLink },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: "",
    },
    activeIndex: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      onlyOneChild: null,
    };
  },

  computed: {
    ...mapGetters(["activeMenu"]),
  },

  created() {},

  mounted() {},

  methods: {
    isDevMenu(code) {
      return code?.split("-").includes("dev");
    },
    hasOneShowingChild(appColumnRespVOList = [], parent) {
      if (!appColumnRespVOList) {
        appColumnRespVOList = [];
      }
      const showingChildren = appColumnRespVOList.filter((item) => {
        if (!item.visible) {
          return false;
        } else {
          this.onlyOneChild = item;
          return true;
        }
      });

      if (showingChildren.length === 1) {
        return true;
      }

      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: "", noShowingChildren: true };
        return true;
      }

      return false;
    },
    resolvePath(routePath, routeQuery) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      if (routeQuery) {
        const query = JSON.parse(routeQuery);
        return { path: path.resolve(this.basePath, routePath), query: query };
      }
      return path.resolve(this.basePath, routePath);
    },
    activeMenuChange() {
      const activeMenu = this.activeMenu;
      if (this.onlyOneChild.target) {
        this.$store.dispatch("permission/changeActiveMenu", {
          ...activeMenu,
          path: "/null",
        });
        setTimeout(() => {
          this.$store.dispatch("permission/changeActiveMenu", activeMenu);
        });
      }
    },
    devMenuClick() {
      this.$alert("敬请期待！", "提示");
    },
  },
};
</script>

<style scoped lang="scss"></style>
